export const translations = {
  'es-ES': {
    translation: {
      showToday: 'Mostrar hoy',
      outOfRange: 'Fuera de rango',
      selectUpToDays: 'Seleccione la fecha en un plazo de {maxDays} días',
      From: 'Desde',
      FromToDateRangeError:
        'La fecha de finalización no puede ser anterior a la fecha de inicio',
      to: 'a',
      dateFrom: 'Fecha de inicio',
      loadingError: 'Error de carga',
      contactAdmin:
        'Actualice la página para cargar los datos. Póngase en contacto con el administrador si el problema persiste.',
      searchFor: 'Buscar',
      nodes: 'Nodos',
      cancel: 'Cancelar',
      back: 'Atrás',
      saveAndContinue: 'Guardar y continuar',
      yes: 'Sí',
      no: 'No',
      selectDateRange: 'Seleccione el rango de fechas entre {días} días',
      Today: 'Hoy',
      Yesterday: 'Ayer',
      LastWeek: 'La semana pasada',
      ThisMonth: 'este mes',
      LastMonth: 'Mes pasado',
      Last3Months: 'Últimos 3 meses',
      Last6Months: 'Últimos 6 meses',
      YearToDate: 'El año hasta la fecha',
      LastYear: 'El año pasado',
      datePickerErrorMsg:
        'Seleccione las fechas dentro del rango de {días} meses.',
      datePickerGreaterErrorMessage:
        'Desde la fecha no puede ser mayor que hasta la fecha',
      Duration: 'Duración',
      To: 'To',
      apply: 'Aplicar',
      name: 'nombre',
      type: 'tipo',
      Finish: 'Finalizar'
    }
  }
};
